export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "LEAD_INFOGROUP": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("Lead")), " ", _interpolate(_named("InfoGroup"))])},
        "ENTER_NUMBER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type a number"])},
        "MIN": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Min"])},
        "MAX": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max"])},
        "NUMBER_VALIDATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maximum value cannot be lower than minimum"])},
        "NO_OPTION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No results found."])},
        "FROM": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["From"])},
        "TO": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To"])},
        "TRUE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["True"])},
        "FALSE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["False"])},
        "NONE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["None"])}
      }
    }
  })
}
